export default "__VITE_ASSET__e9c58202__"